<template>
	<div class="Quota">
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<div class="btngroup">
				<CommonBtngroup ref="btngroup" :qhide="false" @showclick="showclick" @hide="hide" @select="select"
					@reset="reset"></CommonBtngroup>
			</div>
		</div>
		<div class="BottomTable">
			<div style="display: inline-block;">
				<CommonbtnUpLoad v-if="qx.add" backgroundColor="#FFF" title="批量生成" fontSize="14px"
					@getFile="BatchGeneration" :src="require('@/assets/channel/generation.png')">
				</CommonbtnUpLoad>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#F9FAFC" title="导出" fontSize="14px" @btnclick="Export"
					:src="require('@/assets/channel/export.png')">
				</Commonbtn>

			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#F9FAFC" title="批量打印" fontSize="14px" @btnclick="Print"
					:src="require('@/assets/channel/Print.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.del" backgroundColor="#F9FAFC" title="删除" fontSize="14px" @btnclick="del"
					:src="require('@/assets/icon/icon-del.png')">
				</Commonbtn>
			</div>
			<!--  v-if="qx.enabled" -->
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.approval" backgroundColor="#FFF" title="驳回" fontSize="14px"
					@btnclick="Rejectapproval" :src="require('@/assets/channel/Rejectapproval.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#F9FAFC" v-if="qx.approval" title="提交" fontSize="14px"
					@btnclick="AuthorityConfirm" :src="require('@/assets/icon/qy.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.approval" backgroundColor="#F9FAFC" title="审核" fontSize="14px"
					@btnclick="AuthorityVerify" :src="require('@/assets/icon/shen.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#F9FAFC" title="批量下载" fontSize="14px" @btnclick="DownloadAll"
					:src="require('@/assets/channel/all-download.png')">
				</Commonbtn>
			</div>
			<div style="margin-left: 10px;display: inline-block;" v-if="qx.add">
				<a class="Dowload" style="text-decoration: underline;" @click="DownloadTemplate">下载模版</a>
			</div>
			<div class="Table">
				<Commontable ref="refTableCenter" @handleSelectionChange="handleSelectionChange" @Look="Look"
					@Download="Download" @PrintClick="PrintClick" @onRowClick="onRowClick" width="1000px" colnum=522
					:tableData="tableData" :headerData="headerData" height="100%">
				</Commontable>
				<div class="pagination">
					<Pagination ref="invPagination" type='allColor' :pageSize="pageSize"
						@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
					</Pagination>
				</div>
			</div>
		</div>
		<DialogFrom width="1200px" title="指标单模版" :OKASCAN="false" :dialogVisible="dialogVisibPowerattorneytemplate"
			@cancel="cancelPowerattorneytemplate" @dialogOK="dialogOKPowerattorneytemplate">
			<object :data="fileUrl" type="application/pdf" width="100%" height="750px"></object>
		</DialogFrom>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<DialogFrom width="1000px" title="驳回原因" :dialogVisible="dialogVisibRejectapproval"
			@cancel="cancelRejectapproval" @dialogOK="dialogOKRejectapproval">
			<el-input type="textarea" placeholder="请输入驳回原因" v-model="RejectReason">
			</el-input>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleDel" @cancel="cancelDel" @dialogOK="dialogOKDel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除这条信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleAuthorityVerify" @cancel="cancelAuthorityVerify"
			@dialogOK="dialogOKAuthorityVerify" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要审核这条信息吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleAuthorityConfirm"
			@cancel="cancelAuthorityConfirm" @dialogOK="dialogOKAuthorityConfirm"
			:src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认这条信息吗？</span>
		</Dialog>
		<!-- <div v-show="false">
      <QuotaManageComAll :QuotaList="QuotaList" ref="QUrefAll"></QuotaManageComAll>
    </div> -->
	</div>
</template>

<script>
	import FromComm from '../../../components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../../../components/commongroup.vue'
	import Commonbtn from '../../../../../../components/common-btn.vue'
	import Commontable from '../../../../../../components/common-table.vue'
	import Pagination from '../../../../../../components/pagination.vue'
	import DialogFrom from '../../../../../../components/dialog-from.vue'
	import CommonbtnUpLoad from '../../../../../../components/common-upload.vue'
	import Dialog from '../../../../../../components/dialog.vue'
	import utils from '../../../../../../common/utils'
	import QuotaManageCom from './components/QuotaManageCom.vue'
	import QuotaManageComAll from './components/QuotaManageComAll.vue'
	import FromArr from './FromData/FromArr'
	import headerData from './TableData/headerData'
	import {
		CustomerQuotaList,
		CustomerQuotaDownloadTemplet,
		CustomerQuotaExport,
		InventoryClassList,
		CustomerQuotaDelete,
		DownCustomerQuota,
		GetStatusForCustomerQuota
	} from '@/api/home'
	import {
		CustomerQuotaView,
		CustomerQuotaGeneratePdf,
		CustomerQuotaImport,
		CustomerQuotaVerify,
		CustomerQuotaConfirm,
		CustomerQuotaReject
	} from '@/api/channel'
	export default {
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			Commontable,
			Pagination,
			DialogFrom,
			QuotaManageCom,
			QuotaManageComAll,
			CommonbtnUpLoad,
			Dialog
		},
		props: {},
		data() {
			return {
				fileUrl: '',
				dialogVisibleAuthorityConfirm: false,
				dialogVisibPowerattorneytemplate: false,
				dialogVisibleAuthorityVerify: false,
				dialogVisiblesdrjg: false,
				dialogVisibleDel: false,
				dialogVisibRejectapproval: false,
				GCTQORGCYL: false,
				PageIndex: 1,
				pageSize: 10,
				total: 0,
				QuotaData: [],
				QuotaList: [],
				QuotaArrSelect: [],
				FromArr: [],
				headerData: [],
				tableData: [],
				tableDatadrjg: [],
				Quotaarr: [],
				qus: [],
				title: "",
				RejectReason: "",
				StyleCss: {
					position: 'relative',
					left: -930,
					right: -62,
					opacityGCTQ: 1,
					opacityGQYL: 0
				},
				from: {
					CusName: '',
					InvClass: '',
					Year: '',
					CreateTime1: '',
					CreateTime2: '',
					Status: ''
				},
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					revoke: false, //弃审
					changeth: false, //弃审
					approval: false, //驳回OR审批通过
				},
			}
		},
		created() {
			this.CustomerQuotaList()
			this.getStatus();
			this.inventoryClassList()
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.headerData = JSON.parse(JSON.stringify(headerData))
		},
		activated() {},
		updated() {},
		methods: {
			// 列表
			async getStatus() {
				let {
					code,
					data,
					message
				} = await GetStatusForCustomerQuota({})
				if (code == 0) {
					this.FromArr[4].options = []
					data.map((item, index) => {
						this.FromArr[4].options.push({
							key: item.Value,
							value: item.Text
						})
					})
				} else {
					this.$notify.error({
						title: '提示',
						message: message
					})
				}
			},
			// 列表
			async CustomerQuotaList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					code,
					data,
					message
				} = await CustomerQuotaList({
					Status: this.from.Status,
					QuotaType: 1,
					CusName: this.from.CusName,
					InvClass: this.from.InvClass,
					Year: this.from.Year,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					pageSize: this.pageSize,
					pageIndex: this.PageIndex
				})
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data
				} else {
					this.$notify.error({
						title: '提示',
						message: message
					})
				}
				loading.close();
			},
			// 指标批量生成
			async CustomerQuotaImport(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await CustomerQuotaImport(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						this.CustomerQuotaList()
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = '导入结果'
						this.$message({
							type: 'error',
							message: res.message
						})
					}
					loading.close();
				}
			},
			//   批量生成
			BatchGeneration(file) {
				this.CustomerQuotaImport(file)
			},
			// 导出
			async CustomerQuotaExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await CustomerQuotaExport({
					QuotaType: 1,
					Status: this.from.Status,
					CusName: this.from.CusName,
					InvClass: this.from.InvClass,
					Year: this.from.Year,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					pageSize: this.pageSize,
					pageIndex: this.PageIndex
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `客户指标${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			// 导出
			Export() {
				this.CustomerQuotaExport()
			},
			// 批量打印
			Print() {
				if (this.QuotaArrSelect.length > 0) {
					let IDs = [];
					this.QuotaArrSelect.forEach((item, index) => {
						IDs.push(item.ID);
					})
					this.CustomerQuotaGeneratePdf('iDs', IDs, 'Print');
				} else {
					this.$message.warning('请选择需要打印的数据')
				}
			},
			// 下载模板接口
			async CustomerQuotaDownloadTemplet() {
				let {
					data,
					code,
					message
				} = await CustomerQuotaDownloadTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 下载模板
			DownloadTemplate() {
				this.CustomerQuotaDownloadTemplet()
			},
			// 查看
			async CustomerQuotaView(id) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let res = await CustomerQuotaGeneratePdf({
					ID: id
				})
				if (res) {
					//获取blob链接
					this.fileUrl = window.URL.createObjectURL(new Blob([res], {
						type: 'application/pdf'
					}))
					this.dialogVisibPowerattorneytemplate = true;
					// }
				} else {
					this.$message.warning(`预览失败`);
				}
				loading.close();
			},
			// 指标打印/下载
			async CustomerQuotaGeneratePdf(key, value, type, fileName) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let res = await CustomerQuotaGeneratePdf({
					[key]: value
				})
				if (res) {
					if (type == 'download') {
						let date = new Date();
						let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`;
						utils.downloadFile(res, `${fileName}-${str}`, "pdf");
					}
					if (type == 'Print') {
						utils.downloadFilePdfStream(res, "application/pdf");
					}
				} else {
					if (type == 'download') {
						this.$message.warning(`导出失败`);
					}
					if (type == 'Print') {
						this.$message.warning(`打印失败`);
					}
				}
				loading.close();
			},
			async DownloadAll() {
				if (this.QuotaArrSelect.length > 0) {
					let IDs = [];
					this.QuotaArrSelect.forEach((item, index) => {
						IDs.push(item.ID);
					})
					const loading = this.$loading({
						lock: true,
						text: '加载中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let res = await DownCustomerQuota({
						iDs: IDs
					})
					if (res) {
						let date = new Date();
						let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`;
						utils.downloadFile(res, `指标生成批量下载-${str}`, "rar");
					} else {
						this.$message.warning(`导出失败`);
					}
					loading.close();
				} else {
					this.$message.warning('请选择需要下载的数据')
				}
			},
			// 指标删除
			async CustomerQuotaDelete(BAMIDs) {
				console.log(BAMIDs, 'BAMIDs');
				let {
					code,
					message
				} = await CustomerQuotaDelete({
					IDs: BAMIDs
				})
				if (code == 0) {
					this.CustomerQuotaList()
					this.$message.success(message)
					this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection();
				} else {
					this.$message.warning(message)
				}
			},
			// 指标删除
			del() {
				if (this.QuotaArrSelect.length == 0) {
					this.$message.warning('请选择您要操作的数据（多选）')
					return
				}
				this.dialogVisibleDel = true
			},
			// 单行查看
			Look(row) {
				console.log(row, '单行查看');
				this.CustomerQuotaView(row.ID)
			},
			// 单行下载
			Download(row) {
				this.CustomerQuotaGeneratePdf('id', row.ID, 'download', row.CusName);
				console.log(row, '单行下载');
			},
			// 单行打印
			PrintClick(row) {
				console.log(row, '单行打印');
				this.CustomerQuotaGeneratePdf('id', row.ID, 'Print', row.CusName);
			},
			// 归创通桥下载
			GCTQdownload(QuotaData) {
				this.Download(QuotaData);
			},
			// 归创通桥打印
			GCTQPrint(QuotaData) {
				this.PrintClick(QuotaData);
			},
			//归创医疗下载
			GCYLdownload(QuotaData) {
				this.Download(QuotaData)
			},
			// 归创医疗打印
			GCYLPrint(QuotaData) {
				this.PrintClick(QuotaData)
			},
			rightClick() {
				this.$nextTick(() => {
					this.StyleCss.right = -62
					this.StyleCss.left = -1000
					this.StyleCss.opacityGCTQ = 1
					this.StyleCss.opacityGQYL = 0
				})
				this.GCTQORGCYL = true
			},
			leftClick() {
				this.$nextTick(() => {
					this.StyleCss.left = 0
					this.StyleCss.right = -1000
					this.StyleCss.opacityGCTQ = 0
					this.StyleCss.opacityGQYL = 1
				})
				this.GCTQORGCYL = false
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.FromArr[1].options = []
					this.FromArr[2].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							label: item.InvClassName,
							value: item.InvClass,
						}
						this.FromArr[1].options.push(obj)
					})
					let date = new Date()
					let yearArr = [
						date.getFullYear() - 1,
						date.getFullYear(),
						date.getFullYear() + 1
					]
					yearArr.map((item, index) => {
						let obj = {
							key: item,
							value: item
						}
						this.FromArr[2].options.push(obj)
					})
				} else {
					this.$message.error('公司加载失败')
				}
			},
			//  驳回接口
			async CustomerQuotaReject() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let IDs = []
				this.QuotaArrSelect.forEach((item, index) => {
					IDs.push(item.ID)
				})
				let {
					code,
					data,
					message
				} = await CustomerQuotaReject({
					IDs: IDs,
					RejectReason: this.RejectReason
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibRejectapproval = false;
					this.CustomerQuotaList()
					this.QuotaArrSelect = [];
					this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection();
				} else if (code == 1) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = '驳回结果'
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 驳回
			Rejectapproval() {
				if (this.QuotaArrSelect.length == 0) {
					this.$message.warning('请选择您要操作的数据（多选）')
				} else {
					this.dialogVisibRejectapproval = true
				}
			},
			// 审核
			async CustomerQuotaVerify() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let IDs = []
				this.QuotaArrSelect.forEach((item, index) => {
					IDs.push(item.ID)
				})
				let {
					code,
					data,
					message
				} = await CustomerQuotaVerify({
					IDs: IDs
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibleAuthorityVerify = false;
					this.CustomerQuotaList();
					this.QuotaArrSelect = [];
					this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection();
				} else if (code == 1) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = '审核结果'
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 确认
			async CustomerQuotaConfirm() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let IDs = []
				this.QuotaArrSelect.forEach((item, index) => {
					IDs.push(item.ID)
				})
				let {
					code,
					data,
					message
				} = await CustomerQuotaConfirm({
					IDs: IDs
				})
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibleAuthorityConfirm = false;
					this.QuotaArrSelect = [];
					this.CustomerQuotaList()
					this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection();
				} else if (code == 1) {
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
					this.title = '确认结果'
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 审核
			AuthorityVerify() {
				if (this.QuotaArrSelect.length == 0) {
					this.$message.warning('请选择您要操作的数据（多选）')
				} else {
					this.dialogVisibleAuthorityVerify = true
				}
			},
			// 确认
			AuthorityConfirm() {
				if (this.QuotaArrSelect.length == 0) {
					this.$message.warning('请选择您要操作的数据（多选）')
				} else {
					this.dialogVisibleAuthorityConfirm = true
				}
			},

			showclick() {

			},
			hide() {

			},
			select() {
				this.from.CusName = this.FromArr[0].modelvalue
				this.from.InvClass = this.FromArr[1].modelvalue ? this.FromArr[1].modelvalue.join(',') : '';
				this.from.Year = this.FromArr[2].modelvalue
				this.from.CreateTime1 = this.FromArr[3].StartTime
				this.from.CreateTime2 = this.FromArr[3].EndTime
				this.from.Status = this.FromArr[4].modelvalue
				this.CustomerQuotaList()
				this.QuotaArrSelect = [];
				this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection();
			},
			reset() {
				this.FromArr.map((item, index) => {
					if (index == 3) {
						item.StartTime = '';
						item.EndTime = '';
					}
					item.modelvalue = '';
				})
				this.QuotaArrSelect = [];
				this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection();
			},
			handleSelectionChange(val) {
				console.log(val, 'val');
				this.QuotaArrSelect = val;
			},
			onRowClick(val) {
				console.log(val, 'val');
			},
			handleCurrentChange(PageIndex) {
				this.PageIndex = PageIndex
				this.CustomerQuotaList()
				this.QuotaArrSelect = [];
				this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection();
			},
			handleSizeChange(PageSize) {
				this.pageSize = PageSize
				this.CustomerQuotaList()
				this.QuotaArrSelect = [];
				this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection();
			},
			cancelPowerattorneytemplate() {
				this.dialogVisibPowerattorneytemplate = false
			},
			dialogOKPowerattorneytemplate() {
				this.dialogVisibPowerattorneytemplate = false
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
			cancelDel() {
				this.dialogVisibleDel = false
			},
			cancelRejectapproval() {
				this.dialogVisibRejectapproval = false
			},
			dialogOKRejectapproval() {
				this.CustomerQuotaReject()
				// this.dialogVisibRejectapproval = false
			},
			cancelAuthorityVerify() {
				this.dialogVisibleAuthorityVerify = false
			},
			dialogOKAuthorityVerify() {
				this.CustomerQuotaVerify()
			},
			cancelAuthorityConfirm() {
				this.dialogVisibleAuthorityConfirm = false
			},
			dialogOKAuthorityConfirm() {
				this.CustomerQuotaConfirm()
			},
			dialogOKDel() {
				let ID = []
				this.QuotaArrSelect.forEach((item, index) => {
					ID.push(item.ID)
				})
				this.CustomerQuotaDelete(ID)
				this.dialogVisibleDel = false
			},
		},
		computed: {},
		watch: {
			dialogVisibRejectapproval: {
				handler(newVal, OldVal) {
					if (!newVal) {
						this.RejectReason = ''
					}
				}
			},
			$route: {
				handler(to, from) {
					let data = JSON.parse(localStorage.getItem("MenusData"))
					data.CusWebMenus.forEach((item, index) => {
						if (item.NodeID == 77) {
							item.Nodes.forEach((items, indexs) => {
								if (items.NodeID == to.query.NodeID) {
									items.Nodes.forEach((itemes, indexes) => {
										if (itemes.NodeID == to.query.MenuID) {
											let itemsss = itemes.Nodes.filter(item => item
												.NodeID == 153)[0];
											this.qus = itemsss.Buttons;
										}
									})
								}
							})
						}
					});
					console.log(this.qus, 'qus');
					if (this.qus) {
						this.qus.map((item, index) => {
							if (item.NodeName == 'add') {
								this.qx.add = true
							} else if (item.NodeName == 'edit') {
								this.qx.update = true
							} else if (item.NodeName == 'delete') {
								this.qx.del = true
							} else if (item.NodeName == 'stopif') {
								this.qx.del = true
							} else if (item.NodeName == 'assignment') {
								this.qx.assignment = true
							} else if (item.NodeName == 'enabled') {
								this.qx.enabled = true
							} else if (item.NodeName == 'skip') {
								this.qx.skip = true
							} else if (item.NodeName == 'reset') {
								this.qx.reset = true
							} else if (item.NodeName == 'setting') {
								this.qx.setting = true
							} else if (item.NodeName == 'submit') {
								this.qx.submit = true
							} else if (item.NodeName == 'approval') {
								this.qx.approval = true
							}
						})
					}
				},
				deep: true,
				immediate: true
			}
		},
	}
</script>
<style scoped lang='less'>
	.GCTQ {
		// border: 1px solid red;
		transition: all 0.5s;
	}

	.GCYL {
		//  border: 1px solid rgb(23, 120, 211);
		transition: all 0.5s;
	}

	.Quota {
		width: 100%;
		height: 100%;
		position: relative;

		.TopSearch {
			/* margin: 1px 10px;
    width: 938px; */
			margin-top: 24px;
			height: 200px;
			// border: 1px solid #e5e7ea;
			// padding-bottom: 10px;
			box-shadow: 0px 1px 4px 2px #e5e7ea;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;

			.btngroup {
				// border: 1px solid #0b65ec;
				position: relative;
				bottom: 20px;
			}
		}

		.BottomTable {
			/* margin: 32px 10px; */
			padding: 10px;
			/* width: 920px; */
			margin-top: 24px;
			// height: 518px;
			// border: 1px solid #e5e7ea;
			box-shadow: 0px 1px 4px 2px #e5e7ea;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
		}
	}
</style>